export class ListDlsgPoliciesResponse {
    'dlsgPolicies';
    'nextToken';
    'totalCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dlsgPolicies",
            "baseName": "dlsgPolicies",
            "type": "Array<DlsgPolicy>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDlsgPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
